import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { useQuery } from "react-query";
import {
  fetchStockCategories,
  fetchStockClasses,
  fetchSuppliers,
  fetchStoreLocations,
  fetchStores,
  fetchLevies,
  fetchUnits,
} from "services/fetchData";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import axios from "axios";

// firebase
import { storage } from "services/firebase";
import { baseUrl } from "utils/api";
import AddImageItem from "./AddImageItem";

export default function AddNewStockItem() {
  const { register, errors, handleSubmit } = useForm();
  const token = localStorage.getItem("token");
  const { addToast } = useToasts();
  let history = useHistory();

  const addItem = async (item) => {
    var config = {
      method: "post",
      url: `${baseUrl}stocks`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: item,
    };

    await axios(config)
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          console.log(response);
          history.push("/admin/file-maintainance/stock-items");
          addToast("Successfully create new stock item", {
            appearance: "success",
            autoDismiss: true,
          });
        }
      })
      .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }

        addToast(`${error.message}`, {
          appearance: "error",
          autoDismiss: true,
        });
        return error;
      });
  };

  const { data: categories } = useQuery("categories", fetchStockCategories);

  const { data: classes } = useQuery("classes", fetchStockClasses);

  const { data: suppliers } = useQuery("suppliers", fetchSuppliers);

  const { data: stores } = useQuery("stores", fetchStores);

  const { data: storeLocations } = useQuery(
    "storeLocations",
    fetchStoreLocations
  );

  const { data: leviesData } = useQuery("levies", fetchLevies);

  const { data: unitsData } = useQuery("units", fetchUnits);

  const checkImage = (file) =>
    new Promise((resolve, reject) => {
      let img = new Image();
      var objectUrl = URL.createObjectURL(file);
      let width;
      img.onload = function () {
        resolve([this.width, this.height]);
        URL.revokeObjectURL(objectUrl);
      };
      img.src = objectUrl;
    });

  const uploadImage = (file) =>
    new Promise((resolve, reject) => {
      const uploadTask = storage.ref(`images/${file.name}`).put(file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          reject(error);
        },
        () => {
          storage
            .ref("images")
            .child(file.name)
            .getDownloadURL()
            .then((url) => {
              resolve(url);
            });
        }
      );
    });

  const onSubmit = async (data) => {
    data.units_2 = "";
    data.units_3 = "";
    data.pack_1 = "1";
    data.pack_2 = "0";
    data.pack_3 = "0";
    data.levy_2 = "S";
    data.levy_3 = "";
    data.price_2 = "0";
    data.price_3 = "0";
    data.stk = 1;
    data.del = "0";
    data.label1_desc = "";
    data.label2_desc = "";
    data.c_sel = "0";
    data.id = "";

    data.topCode = "";
    data.type = "";
    data.vat_perc = 0;

    data.barcode = null;

    data.stockBal = null;

    checkImage(data.image[0]).then(function (response) {
      if (response[0] > 300 && response[1] > 300) {
        addToast(
          "Image size should be width max of 300 and height max of 300",
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      } else if (data.image[0].size > 3145730) {
        addToast("Image size should be 3mb or less", {
          appearance: "error",
          autoDismiss: true,
        });
      } else {
        uploadImage(data.image[0]).then(
          function (res) {
            data.image_url = res;
            data.stockImagez = [
              {
                itemId: "8394a07c-a17f-4fea-9ee5-867bdab0d622",
                code: data.code,
                image_url: res,
                color: data.color,
                c_sel: 0,
              },
            ];
            addItem(data);
          },
          function (error) {
            console.error(error);
          }
        );
      }
    });
  };

  return (
    <>
      <div
        className="relative  min-w-0 break-words w-full bg-gray-200 border-0"
        style={{ paddingTop: "4rem" }}
      >
        <div
          className="flex flex-col shadow-lg rounded-lg mb-6"
          style={{ margin: "3rem" }}
        >
          <div className="rounded-t bg-white mb-0 px-6 py-6">
            <div className="">
              <h6 className="text-gray-800 text-xl font-bold">
                Add New Stock Item
              </h6>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1rem",
                }}
              >
                <Link
                  to="/admin/dashboard"
                  className="text-sm hover:text-gray-200 lg:inline-block font-semibold"
                  style={{ color: "#6e7581" }}
                >
                  DASHBOARD
                </Link>
                <ArrowForwardIosIcon
                  style={{
                    color: "#6e7581",
                    fontSize: "12px",
                    margin: "0 1rem",
                  }}
                />
                <Link
                  to="/admin/file-maintainance"
                  className=" text-sm hover:text-gray-200 lg:inline-block font-semibold"
                  style={{ color: "#6e7581" }}
                >
                  FILE MAINTAINANCE
                </Link>
                <ArrowForwardIosIcon
                  style={{
                    color: "#6e7581",
                    fontSize: "12px",
                    margin: "0 1rem",
                  }}
                />
                <Link
                  to="/admin/file-maintainance/stock-items"
                  className=" text-sm hover:text-gray-200 lg:inline-block font-semibold"
                  style={{ color: "#6e7581" }}
                >
                  STOCK ITEMS
                </Link>
                <ArrowForwardIosIcon
                  style={{
                    color: "#6e7581",
                    fontSize: "12px",
                    margin: "0 1rem",
                  }}
                />
                <span
                  className="text-sm uppercase hidden lg:inline-block font-semibold"
                  style={{ color: "rgb(194 216 234)" }}
                >
                  ADD STOCK ITEM
                </span>
              </div>
            </div>
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form>
              <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Item Details
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="code"
                    >
                      Item Code
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="code"
                      placeholder="code"
                      ref={register({ required: true })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.code && "Item code is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="name"
                    >
                      Item Name
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="name"
                      name="name"
                      ref={register({ required: true })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.name && "Name is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="category"
                    >
                      Category
                    </label>
                    <select
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="category"
                      ref={register({ required: true })}
                    >
                      <option value="">Select Category...</option>
                      {categories?.map((el, i) => (
                        <option value={el.id} key={i}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.category && "Category is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="supplier"
                    >
                      Supplier
                    </label>
                    <select
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="supplier"
                      ref={register({ required: true })}
                    >
                      <option value="">Select Supplier...</option>
                      {suppliers?.map((el, i) => (
                        <option value={el.id} key={i}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.supplier && "Supplier is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="store"
                    >
                      Store
                    </label>
                    <select
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="store"
                      ref={register({ required: true })}
                    >
                      <option value="">Select Store...</option>
                      {stores?.map((el, i) => (
                        <option value={el.id} key={i}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.store && "Store is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="location"
                    >
                      Store Location
                    </label>
                    <select
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="location"
                      ref={register({ required: true })}
                    >
                      <option value="">Select Location...</option>
                      {storeLocations?.map((el, i) => (
                        <option value={el.id} key={i}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.location && "Location is required"}
                    </span>
                  </div>
                </div>
              </div>

              <hr className="mt-6 border-b-1 border-gray-400" />

              <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Description
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="description"
                    >
                      Description
                    </label>
                    <textarea
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      rows="4"
                      name="description"
                      ref={register({ required: true })}
                    ></textarea>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.description && "Description is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="clasz"
                    >
                      Class
                    </label>
                    <select
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="clasz"
                      ref={register({ required: true })}
                    >
                      <option value="">Select Class...</option>
                      {classes?.map((el, i) => (
                        <option value={el.id} key={i}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.clasz && "Clasz is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="units_1"
                    >
                      Units
                    </label>
                    <select
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="units_1"
                      ref={register({ required: false })}
                    >
                      <option value="">Select Units...</option>
                      {unitsData?.map((el, i) => (
                        <option value={el.id} key={i}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.units_1 && "Units is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="pack_1"
                    >
                      Pack
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="pack"
                      name="pack_1"
                      ref={register({ required: false })}
                    />

                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.pack_1 && "Pack is required"}
                    </span>
                  </div>
                </div>

                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="weight"
                    >
                      Weight
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="weight"
                      name="weight"
                      ref={register({ required: false })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.weight && "Weight is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="ord_lvl"
                    >
                      Order Level
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="order level"
                      name="ord_lvl"
                      ref={register({ required: false })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.ord_lvl && "Order level is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="leadtime"
                    >
                      Lead Time
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="leadtime"
                      name="leadtime"
                      ref={register({ required: false })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.leadtime && "Leadtime is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="frezze"
                    >
                      Freeze
                    </label>
                    <select
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="frezze"
                      ref={register({ required: true })}
                    >
                      <option value={0}>Default</option>
                      <option value={1}>Stock Out</option>
                      <option value={2}>Suspend</option>
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.frezze && "frezze is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="levy_1"
                    >
                      Levies
                    </label>
                    <select
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="levy_1"
                      ref={register({ required: true })}
                    >
                      <option value="">Select Levy...</option>
                      {leviesData?.map((el, i) => (
                        <option value={el.id} key={i}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.levy_1 && "Levy is Required"}
                    </span>
                  </div>
                </div>
              </div>

              <hr className="mt-6 border-b-1 border-gray-400" />
              <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Pricing Details
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="price_1"
                    >
                      Price
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="price_1"
                      placeholder="price"
                      ref={register({ required: true })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.price_1 && "Price is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="min_price"
                    >
                      Minimum price
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="min_price"
                      placeholder="min price"
                      ref={register({ required: true })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.min_price && "Minimum price is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="cost_price"
                    >
                      Cost Price
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="cost_price"
                      placeholder="cost price"
                      ref={register({ required: true })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.cost_price && "Cost price is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="avwcost"
                    >
                      Average Price
                    </label>
                    <input
                      type="number"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="avwcost"
                      placeholder="average cost"
                      ref={register({ required: false })}
                    />
                  </div>
                </div>
              </div>
              <hr className="mt-6 border-b-1 border-gray-400" />

              <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Stock Item Image
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="image"
                    >
                      Image
                    </label>
                    <input
                      type="file"
                      name="image"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      ref={register({ required: true })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.image && "Image is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="color"
                    >
                      Color
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="color"
                      name="color"
                      ref={register({ required: false })}
                    />
                  </div>
                </div>
                <div className="text-center flex justify-between">
                  <button
                    className="bg-blue-500 text-white active:bg-blue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    type="button"
                    style={{
                      marginTop: "2rem",
                    }}
                    onClick={handleSubmit(onSubmit)}
                  >
                    Add Item
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
